import { createFileRoute, Outlet } from '@tanstack/react-router';

// ENG-1022 Bill of Materials: its own nav section, like Operating Costs. Usage
// is its first view; the imports live under Settings at `/material-imports`.
export const Route = createFileRoute('/materials')({
  staticData: {
    section: 'Materials',
    breadcrumb: 'Materials',
    permissionSection: 'materials',
  },
  component: Outlet,
});
